/*
 * Page Name
 */

jQuery(document).ready(function () {
    if (jQuery("#message_block03_gallery").length > 0) {
        Carousel(
            document.getElementById("message_block03_gallery"),
            {
                infinite: true,
                center: false,
                fill: false,
                dragFree: true,
                slidesPerPage: 4,
                transition: "slide",
                Autoscroll: {
                    autoStart: true,
                    speed: 6,
                    pauseOnHover: false,
                    pauseOnFocus: false
                }
            },
            {
                Autoscroll
            }
        ).init();
    }
});